export default __webpack_public_path__ + "static/2-a72c6814377961b5c3b7aacbf9b7c600.jpg";